import { useState } from "react";
import { toast } from "sonner";
import { BadgeCheck, Undo2 } from "lucide-react";
import api, { errMsg } from "@/lib/api";
import { fdate } from "@/lib/fmt";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const PoConfirm = ({ q, onDone }) => {
  const [open, setOpen] = useState(false);
  const [no, setNo] = useState("");
  const [date, setDate] = useState(new Date().toISOString().slice(0, 10));
  const save = async () => {
    try { await api.post(`/quotations/${q.id}/confirm-po`, { po_no: no, po_date: date }); toast.success("Penawaran dikonfirmasi sebagai PO (Deal)"); setOpen(false); onDone(); } catch (e) { toast.error(errMsg(e)); }
  };
  const cancel = async () => {
    if (!window.confirm("Batalkan konfirmasi PO? Status kembali Aktif.")) return;
    try { await api.delete(`/quotations/${q.id}/confirm-po`); toast.success("Konfirmasi PO dibatalkan"); onDone(); } catch (e) { toast.error(errMsg(e)); }
  };
  if (q.po_no) return (
    <div className="flex flex-wrap items-center gap-3 rounded-lg bg-emerald-50 px-3 py-2 text-sm text-emerald-900" data-testid="po-confirmed-info">
      <BadgeCheck className="h-4 w-4" /><span><b>Confirmed as PO</b> • No. PO/SPK: <b data-testid="po-no">{q.po_no}</b> • {fdate(q.po_date)}</span>
      <Button size="sm" variant="outline" className="bg-white" onClick={cancel} data-testid="po-cancel-btn"><Undo2 className="h-4 w-4 mr-1" />Batalkan Confirm PO</Button>
    </div>
  );
  return (
    <>
      <Button size="sm" className="bg-emerald-700 hover:bg-emerald-800" disabled={q.status === "lost"} onClick={() => setOpen(true)} data-testid="po-confirm-btn"><BadgeCheck className="h-4 w-4 mr-1" />Confirmed as PO</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent aria-describedby={undefined} data-testid="po-dialog">
          <DialogHeader><DialogTitle className="font-heading">Confirmed as PO — {q.display_no}</DialogTitle></DialogHeader>
          <label className="text-sm font-medium">No. PO / SPK</label>
          <Input value={no} onChange={(e) => setNo(e.target.value)} placeholder="mis. PO/2026/0123" data-testid="po-no-input" />
          <label className="text-sm font-medium">Tanggal PO</label>
          <Input type="date" value={date} onChange={(e) => setDate(e.target.value)} data-testid="po-date-input" />
          <p className="text-xs text-slate-500">Status otomatis menjadi Deal. PDF akan memuat watermark "CONFIRMED AS PO" dan kolom tanda tangan customer.</p>
          <Button className="bg-emerald-700 hover:bg-emerald-800" disabled={!no.trim() || !date} onClick={save} data-testid="po-save-btn">Simpan Konfirmasi</Button>
        </DialogContent>
      </Dialog>
    </>
  );
};
